// extracted by mini-css-extract-plugin
export default {"container":"LO-z","dimension":"MO-z","dimensionLabels":"NO-z"};